module.exports = __webpack_public_path__ + "fonts/Trade-Gothic-Bold.eot";


//////////////////
// WEBPACK FOOTER
// ./Common/fonts/Trade-Gothic-Bold.eot
// module id = 6
// module chunks = 0 1 2 3 4 5 6 7